//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React from 'react';
// import './style.scss'
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';

function Page() {
  const goForWalks = useStore((state) => state.goForWalks);
  const setGoForWalks = useStore((state) => state.setGoForWalks);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.goForWalks.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={goForWalks}
          onChange={(value) => {
            setGoForWalks(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'go-for-walks',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'Very active'}>
            <span>💪</span> {t('onboarding.goForWalks.options.veryActive')}
          </Option>
          <Option value={'Active'}>
            <span>😎</span> {t('onboarding.goForWalks.options.active')}
          </Option>
          <Option value={'Lightly active'}>
            <span>🙂</span> {t('onboarding.goForWalks.options.lightlyActive')}
          </Option>
          <Option value={'Low'}>
            <span>😌</span> {t('onboarding.goForWalks.options.low')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
